import { ChangelogSection } from "../models/changelog.types";

export type ChangelogCategory = ChangelogSection["category"];

export interface ChangelogCategoryMeta {
    /** i18n key. Pass through `| transloco` in templates. */
    label: string;
    /** Heroicons-outline key for `[svgIcon]`. */
    icon: string;
    /** Color accepted by `<ac-badge [color]>`. */
    badgeColor: string;
}

/**
 * Single source of truth for how each changelog category is presented
 * across the list, the detail and the news modal. Keep UI tokens here so
 * drift doesn't creep in when any of the 3 surfaces changes.
 */
const CATEGORY_META: Record<ChangelogCategory, ChangelogCategoryMeta> = {
    feature: {
        label: "What's new",
        icon: "heroicons_outline:sparkles",
        badgeColor: "primary",
    },
    improvement: {
        label: "Improvements",
        icon: "heroicons_outline:arrow-trending-up",
        badgeColor: "tertiary",
    },
    fix: {
        label: "Fixes",
        icon: "heroicons_outline:wrench-screwdriver",
        badgeColor: "warning",
    },
};

const DEFAULT_ICON = "heroicons_outline:tag";
const DEFAULT_BADGE_COLOR = "light";

export function categoryLabel(category: ChangelogCategory): string {
    return CATEGORY_META[category]?.label ?? category;
}

export function categoryIcon(category: ChangelogCategory): string {
    return CATEGORY_META[category]?.icon ?? DEFAULT_ICON;
}

export function categoryBadgeColor(category: ChangelogCategory): string {
    return CATEGORY_META[category]?.badgeColor ?? DEFAULT_BADGE_COLOR;
}
